<template>
    <transition name="slide-fade">
        <div class="detail-popup" v-if="isOpen">
            <div class="detail-popup__wrapper">
                <div class="detail-popup__content">
                    <div class="detail-popup__specs">
                        <div v-if="flat.area" class="detail-popup__specs-item">
                            {{ flat.area }} м<sup>2</sup>
                        </div>

                        <div v-if="flat.title" class="detail-popup__specs-item">
                            {{ computedType }} №{{ flat.title }}
                        </div>
                    </div>

                    <div class="detail-popup__price" v-if="flat.price">
                        {{ Number(flat.price) ? `${convertToDigit(flat.price)} ₽` : flat.price }}
                    </div>

                    <ButtonClose
                        modify="button-close_theme_parametric detail-popup__close"
                        @click="closeOpen" />

                    <div class="detail-popup__plan">
                        <img :src="flat.plan" :alt="flat.title">
                    </div>

                    <transition name="slide-fade">
                        <a :href="flat.link"
                            type="button"
                            class="button button_theme_parametric button_theme_black detail-popup__more">
                            <span>Подробнее</span>
                        </a>
                    </transition>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import ButtonClose from 'components/button-close/ButtonClose.vue';
import {convertToDigit} from '../mixins.js';


export default {
    data() {
        return {
            isOpen: false,
            flat  : null
        };
    },
    components: {
        ButtonClose
    },

    computed: {
        computedType() {
            return Number(this.flat.type) === 0 ? 'Студия' : `${this.flat.type}К-евро`;
        }
    },

    mixins: [convertToDigit],

    methods: {
        openModal(flat) {
            this.flat = flat;
            this.isOpen = true;
        },
        closeOpen() {
            this.isOpen = false;
            this.$emit('closed');
        },
        selectFlat() {
            this.closeOpen();
        }
    }
};
</script>
